// Direct embed: the official script counts initial loads and History API navigation.
// Do not also register router.afterEach page views (that would count them twice).
export default function ({ app }) {
  if (process.env.NODE_ENV !== 'production' ||
      !['jaty.pl', 'www.jaty.pl'].includes(window.location.hostname)) return

  if (document.getElementById('jaty-simple-analytics')) return

  // Use route definitions, never profile slugs, tokens, queries or page titles.
  window.jatyAnalyticsPath = ({ path } = {}) => {
    try {
      const { route } = app.router.resolve(typeof path === 'string' ? path.split(/[?#]/)[0] : '/')
      const match = route.matched[route.matched.length - 1]
      if (!match || match.path.includes('*')) return '/other'
      return match.path.replace(/:slug(?:\([^)]*\))?\??/g, ':profile') || '/'
    } catch (_) {
      // The vendor falls back to the raw URL on a falsy return or thrown error.
      return '/other'
    }
  }

  // The vendor can retain a same-site referrer despite ignore-metrics. Skip
  // documents reached from a private URL rather than expose its original path.
  if (document.referrer) {
    try {
      const referrer = new URL(document.referrer)
      if (['jaty.pl', 'www.jaty.pl'].includes(referrer.hostname) &&
          window.jatyAnalyticsPath({ path: referrer.pathname }) !== referrer.pathname.replace(/\/$/, '') &&
          referrer.pathname !== '/') return
    } catch (_) { return }
  }

  const script = document.createElement('script')
  script.id = 'jaty-simple-analytics'
  script.async = true
  script.src = 'https://scripts.simpleanalyticscdn.com/latest.js'
  script.referrerPolicy = 'no-referrer'
  script.setAttribute('data-path-overwriter', 'jatyAnalyticsPath')
  // Referrers may also contain private profile paths; UTM values are untrusted.
  script.setAttribute('data-ignore-metrics', 'referrer,utm')
  // Keep the default DNT handling. No noscript pixel or automated event capture.
  document.head.appendChild(script)
}
